import { createSelector } from 'reselect';
import sysUtils from 'utils/ShopYourStore';

// TODO(rohit.gulati, 2026-06-02): Replace dummy with real A/B selector
const multiStoreFilteringAbTestSelector = createSelector(() => true);

const isMultiStoreFilteringEnabledSelector = createSelector(multiStoreFilteringAbTestSelector, multiStoreFilteringAbTest => {
    const globalKillswitch = sysUtils.multiStoreFilteringEnabled();
    const isMultiStoreFilteringEnabled = globalKillswitch && multiStoreFilteringAbTest;

    return isMultiStoreFilteringEnabled;
});

export { isMultiStoreFilteringEnabledSelector };
